import { Injectable } from '@angular/core';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { ApiConnectorService } from '../__api/api-connector.service';
import { EventEmitterService } from '../__common/event-emitter.service';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {

  loading = false;

  constructor(private apiConnector: ApiConnectorService,private guiFlow: GuiFlowService,private eventEmmiter: EventEmitterService,private resolver: ResolverService,private commonFunctions: FunctionsService) { }


  reloadDashboardData(){
    this.resolver.getDashboardData(true);
  }

  changeStatus(newStatus,currentCard){
    this.loading = true;
    this.apiConnector.voyjaleasApiRequest('updateFollowUpStatus',currentCard.id,newStatus,null,null,currentCard)
    .subscribe(
      (response) => {
          this.eventEmmiter.onChangeCardStatus(response);
            this.guiFlow.openSimpleSnackBar('Saved', 'success');
            this.reloadDashboardData();
          },
      (error) => {
            this.guiFlow.reportError(error,'crud-fields-data.service');
            this.loading = false;
          }
      );
  }
}
